import { Dialog, DialogActions, DialogContent, IconButton } from "@mui/material"
import packageInfo from "../../package.json"
import CloseIcon from '@mui/icons-material/Close';

export const AppInfo = ({close} : {close: () => void}) => {
  return<Dialog open={true} onClose={close}>
    <DialogContent sx={{width: "20vw", height: "4vh"}}>
      <table style={{width: "100%"}}>
        <tr>
          <td>Version</td>
          <td>{packageInfo.version}</td>
        </tr>
      </table>
    </DialogContent>
    <DialogActions>
      <IconButton onClick={close}><CloseIcon/></IconButton>
    </DialogActions>
  </Dialog>
}